module.exports = __webpack_public_path__ + "static/media/icon-alert-red.1fb94a15.svg";